/* CaMode - titoli prodotto leggibili nelle griglie e nelle ricerche.
   Modifica solo il testo visualizzato: SKU, titoli Shopify e metadati SEO restano invariati. */
(() => {
  'use strict';
  const targets = [
    '.mbss__title',
    '.product-card-wrapper .card__heading a',
    '#predictive-search-results-products-list .predictive-search__item-heading',
    '.quick-add-modal__content-info--bulk-details h3'
  ].join(', ');

  const isCode = (word) => {
    const core = String(word).replace(/^[^\p{L}\p{N}]+|[^\p{L}\p{N}_]+$/gu, '');
    return (core.length >= 3 && /\d/u.test(core) && /\p{L}/u.test(core)) ||
      /^[A-Z]{2,}[._-]$/u.test(word);
  };

  const titleCaseWord = (word) => String(word)
    .toLocaleLowerCase('it-IT')
    .replace(/(^|[-/'’.])(\p{L})/gu, (_, prefix, letter) =>
      prefix + letter.toLocaleUpperCase('it-IT'));

  const formatTitle = (value) => {
    const raw = String(value || '').trim().replace(/\s+/gu, ' ');
    if (!raw) return raw;
    const words = raw.split(' ');
    let codeStart = words.length;
    while (codeStart > 0 && isCode(words[codeStart - 1])) codeStart--;
    return words.map((word, i) => i >= codeStart ? word : titleCaseWord(word)).join(' ');
  };

  const update = (el) => {
    if (!(el instanceof Element) || el.children.length) return;
    const original = el.textContent || '';
    const formatted = formatTitle(original);
    if (formatted && original !== formatted) el.textContent = formatted;
    el.style.setProperty('text-transform', 'none', 'important');
  };

  const scan = (root) => {
    if (root instanceof Element && root.matches(targets)) update(root);
    if (root.querySelectorAll) root.querySelectorAll(targets).forEach(update);
  };

  const init = () => {
    scan(document);
    const observer = new MutationObserver((records) => {
      for (const record of records) {
        if (record.target instanceof Element && record.target.matches(targets)) {
          update(record.target);
        }
        if (record.type === 'characterData' && record.target.parentElement) {
          const parent = record.target.parentElement;
          if (parent.matches(targets)) update(parent);
        }
        for (const node of record.addedNodes || []) {
          if (node.nodeType === 1) scan(node);
        }
      }
    });
    observer.observe(document.body, { childList: true, characterData: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();